import { StorageUser } from "./StorageUser";

export const sendGaEvent = (event, page, params) => {
  if (process.env.REACT_APP_NODE_ENV !== 'production') {
    return;
  }

  if (typeof window.gtag !== 'function') {
    return;
  }

  const storageUser = new StorageUser();

  window.gtag('event', event, { page, store_id: storageUser.getValue('loja'), ...params });
};